
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { NButton, NLoadingCircle } from '@/uikit';
import NThumbnail from '@/uikit/thumbnail/NThumbnail.vue';
import Confidence from '@/components/common/Confidence.vue';
import { EventDetails, ThumbnailPositions } from '@/uikit/thumbnail';
import MatchedCardHelper from '@/common/MatchedCardHelper';

@Options({
  name: 'MatchedCardInfo',
  components: { Confidence, NButton, NLoadingCircle, NThumbnail }
})
export default class MatchedCardInfo extends Vue {
  @Prop({ type: String, required: true })
  type = '';

  @Prop({ type: Object, required: true })
  objectType = '';

  @Prop({ type: Number, required: true })
  id!: number;

  @Prop({ type: [Number, String], required: true })
  objectId!: number | string;

  @Prop({ type: Number, required: false })
  confidence?: number;

  matchedCardHelper = new MatchedCardHelper();

  get thumbnailActions() {
    const result = [{ icon: 'eye-open', name: EventDetails.ShowFullScreen, position: ThumbnailPositions.BottomRight }];
    return result;
  }

  load() {
    this.matchedCardHelper.isLoadObject = true;
    this.matchedCardHelper.isLoadAttachments = true;
    this.matchedCardHelper.type = this.objectType;
    this.matchedCardHelper.cardId = this.id;
  }

  created() {
    this.load();
  }

  @Watch('id')
  changeIdHandler() {
    this.load();
  }

  openFile(path: string) {
    window.open(path, '_blank');
  }
}
